module.exports = __webpack_public_path__ + "static/media/SA.dba1a677.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/SA.svg
// module id = 351
// module chunks = 0